/**
 * Marketing portrait avatars for phone mockups and social UI.
 * Drop `avatar-01.png` … `avatar-08.png` here when available; WebP is used until then.
 */
import avatar01 from './avatar-01.webp';
import avatar02 from './avatar-02.webp';
import avatar03 from './avatar-03.webp';
import avatar04 from './avatar-04.webp';
import avatar05 from './avatar-05.webp';
import avatar06 from './avatar-06.webp';
// TODO: replace with ./avatar-07.png when asset is added
import avatar07 from './avatar-05.webp';
// TODO: replace with ./avatar-08.png when asset is added
import avatar08 from './avatar-06.webp';

export const MARKETING_AVATARS = [
  avatar01,
  avatar02,
  avatar03,
  avatar04,
  avatar05,
  avatar06,
  avatar07,
  avatar08,
] as const;

export type MarketingAvatarSize = 'xs' | 'sm' | 'md' | 'lg';

/** @deprecated Prefer `.avatar-*` CSS sizes in phone mockups. */
export const MARKETING_AVATAR_PX: Record<MarketingAvatarSize, number> = {
  xs: 18,
  sm: 28,
  md: 44,
  lg: 58,
};

/** Pick `count` avatars starting at `start` (wraps). */
export function marketingAvatarSlice(start = 0, count = 4): readonly string[] {
  const n = MARKETING_AVATARS.length;
  return Array.from({ length: count }, (_, i) => MARKETING_AVATARS[(start + i) % n]!);
}
